<script setup lang="ts">
import type { GridColumnProps } from '@progress/kendo-vue-grid'
import { formatCurrency, formatNumber } from '@/lib/format'
import ClientsRepository from '@/repository/ClientsRepository'
import { formatDate } from '@/lib/utils'
import CardTableContent from '@/components/ui/card/CardTableContent.vue'
import Card from '@/components/ui/card/Card.vue'

const columns = [
  { field: 'client_type', title: 'Type de client' },
  { field: 'client_title', title: 'Client' },
  { field: 'date_first_order', title: 'Date première commande' },
  { field: 'date_last_order', title: 'Date dernière commande' },
  { field: 'total_amount_since_first_order', title: 'Montant des propositions' },
  { field: 'total_orders_since_first_order', title: 'Nb de commandes' },
] as GridColumnProps[]

const formatCell = (field: string, value: unknown) => {
  if (field === 'total_orders_since_first_order') {
    return formatNumber(value as unknown as number)
  }
  if (field === 'total_amount_since_first_order') {
    return formatCurrency(value as unknown as number)
  }
  if (field === 'date_first_order' || field === 'date_last_order') {
    return formatDate(value as string)
  }
  return value as string
}

const getData = async (
  skip: number,
  take: number,
  sortField: string,
  sortOrder: 'asc' | 'desc',
) => {
  const response = await ClientsRepository.getTableData(skip, take, sortField, sortOrder)
  return {
    data: response.data,
    total: response.total,
  }
}
</script>

<template>
  <Card title="Clients" :download-excel="ClientsRepository.downloadExcel">
    <CardTableContent
      :columns="columns"
      :get-data="getData"
      :format-cell="formatCell"
      :initial-sort="{ field: 'date_first_order', dir: 'asc' }"
    />
  </Card>
</template>
